import React, { createContext, useState, useContext } from 'react';

// Create Context
export const WizardContext = createContext();

// Create Provider
export const WizardProvider = ({ children }) => {
  // State variables from Step1.js
  const [selectionOption, setSelectionOption] = useState("15th_celebration");

  // State variables from Step2.js
  const [firstname, setFirstname] = useState(null);
  const [lastname, setLastname] = useState(null);
  const [chinesename, setChinesename] = useState(null);
  const [gender, setGender] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [do3R5P, setDo3R5P] = useState(true);
  const [doLunch, setDoLunch] = useState(false);
  const [englishXlation, setEnglishXlation] = useState(false);
  const [cantoneseXlation, setCantoneseXlation] = useState(false);
  const [needShuttleBus, setNeedShuttleBus] = useState(false);
  const [isVolunteering, setIsVolunteering] = useState(false);

  const [s11_5_09_30, setS11_5_09_30] = React.useState(true); // 11/5 Scroll 1, 09:30am-12:30pm
  const [s18_5_09_30, setS18_5_09_30] = React.useState(true); // 18/5 Scroll 2, 09:30am-12:30pm
  const [s1_6_09_30, setS1_6_09_30] = React.useState(true); // 1/6 Scroll 3, 09:30am-12:30pm
  const [s8_6_09_30, setS8_6_09_30] = React.useState(true); // 8/6 Scroll 4, 09:30am-12:30pm
  const [s15_6_09_30, setS15_6_09_30] = React.useState(true); // 15/6 Scroll 5, 09:30am-12:30pm
  const [s6_7_09_30, setS6_7_09_30] = React.useState(true); // 6/7 Scroll 6, 09:30am-12:30pm
  const [s13_7_09_30, setS13_7_09_30] = React.useState(true); // 13/7 Scroll 7, 09:30am-12:30pm
  const [s20_7_09_30, setS20_7_09_30] = React.useState(true); // 20/7 Scroll 8, 09:30am-12:30pm
  const [s3_8_09_30, setS3_8_09_30] = React.useState(true); // 3/8 Scroll 9, 09:30am-12:30pm
  const [s10_8_09_30, setS10_8_09_30] = React.useState(true); // 10/8, 09:30am-04:30pm
  
  

  // State variables from Step3.js
  // Define them similarly...
  // Example:
  const [confirmation, setConfirmation] = useState(false);

  // Functions to validate or manage the steps, if needed, can be defined here too.
  const isValidatedStep1 = () => {
    return selectionOption !== null;
  };

  const isValidatedStep2 = () => {
    // Add your validation logic for Step2 here
    return true;
  };

  const isValidatedStep3 = () => {
    // Add your validation logic for Step3 here
    return true;
  };

  // Export all state variables and setters
  return (
    <WizardContext.Provider
      value={{
        selectionOption, setSelectionOption,
        firstname, setFirstname,
        lastname, setLastname,
        chinesename, setChinesename,
        gender, setGender,
        email, setEmail,
        phone, setPhone,
        do3R5P, setDo3R5P,
        doLunch, setDoLunch,
        confirmation, setConfirmation,
        englishXlation, setEnglishXlation,
        cantoneseXlation, setCantoneseXlation,
        needShuttleBus, setNeedShuttleBus,
        isVolunteering, setIsVolunteering,
        s11_5_09_30, setS11_5_09_30, 
        s18_5_09_30, setS18_5_09_30, 
        s1_6_09_30, setS1_6_09_30, 
        s8_6_09_30, setS8_6_09_30, 
        s15_6_09_30, setS15_6_09_30, 
        s6_7_09_30, setS6_7_09_30, 
        s13_7_09_30, setS13_7_09_30, 
        s20_7_09_30, setS20_7_09_30, 
        s3_8_09_30, setS3_8_09_30, 
        s10_8_09_30, setS10_8_09_30
      }}
    >
      {children}
    </WizardContext.Provider>
  );
};

// Custom hook for using the Wizard Context
export const useWizard = () => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizard must be used within a WizardProvider');
  }
  return context;
};
